import { request } from "@/interface/helper";

const str = "communityRecommend";

export const communityRecommend = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/postrecommend/list" }),
    add: data => request({ data, method: "post", url: "/community/postrecommend/add" }),
    detail: data => request({ data, method: "post", url: "/community/postrecommend/detail" }),
    edit: data => request({ data, method: "post", url: "/community/postrecommend/modify" })
  }
};
